import { render, staticRenderFns } from "./DTOverview.vue?vue&type=template&id=e8edd960&scoped=true"
import script from "./DTOverview.vue?vue&type=script&lang=js"
export * from "./DTOverview.vue?vue&type=script&lang=js"
import style0 from "./DTOverview.vue?vue&type=style&index=0&id=e8edd960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8edd960",
  null
  
)

export default component.exports